import React from "react";
import { CheckBox } from "./Checkbox";
import styles from "./styles.module.scss";

const TableDivider = ({ checkboxHandler, heading, isChecked, disable }) => {
  return (
    <div className={`${styles["table-divider"]}`}>
      <div
        style={{
          position: "sticky",
          left: "0px",
          background: "white",
          borderRight: "1px solid #E2E2E2",
        }}
      >
        <CheckBox
          disabled={disable}
          isChecked={isChecked}
          handler={checkboxHandler}
        ></CheckBox>
      </div>
      <div
        className={`text-bold label-color ${styles["divider-heading"]} ml-1`}
      >
        {heading}
      </div>
      <div className={`${styles["table-div-bottom"]}`}></div>
    </div>
  );
};

export default TableDivider;
